import type { Company } from '@provalia/shared';
import { Badge } from '../../shared/ui';

/** Sociedades de un cliente con su CIF, o el aviso de que viajan sin él. */
export function CompanyCifs({ companies }: { companies: Company[] }): JSX.Element {
  if (companies.length === 0) return <Badge tone="warn">Sin sociedades</Badge>;
  return (
    <ul className="company-cifs">
      {companies.map((c) => (
        <li key={c.id}>
          <span className="mono">{c.companyDb}</span>
          {c.cif ? <span className="mono subtle">{c.cif}</span> : <Badge tone="warn">sin CIF</Badge>}
          {!c.active ? <Badge plain>inactiva</Badge> : null}
        </li>
      ))}
    </ul>
  );
}
